import { createContext } from 'react';
import type { SupabaseDataProvider } from '../../platform/supabase/data-provider';

// Set once in App; absent (isolated tests, previews) the alerts bell isn't shown.
export const AlertsProviderContext = createContext<SupabaseDataProvider | null>(
  null,
);
